// extracted by mini-css-extract-plugin
module.exports = {"McsIconLabelBase":"McsIconLabelRectangle_McsIconLabelBase__1vkCR","McsIconLabelText":"McsIconLabelRectangle_McsIconLabelText__3KGO-"};